import { render, staticRenderFns } from "./EducationalJoiningApplicationInfo.vue?vue&type=template&id=191ebd16&"
import script from "./EducationalJoiningApplicationInfo.vue?vue&type=script&lang=js&"
export * from "./EducationalJoiningApplicationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports